import { MouseEvent } from 'react'

import { useReactiveVar } from '@apollo/client'

import { modalListVar } from '@web/components/Modal/GlobalModal/globalModal.helper'

import ReactionModal, { ReactionModalProps } from './ReactionModal'
import { useModal } from '../../Modal/useModal'

const useReactionModal = () => {
  const { openModal: _openModal, modalId } = useModal(ReactionModal)

  const modalList = useReactiveVar(modalListVar)

  const isReactionModalOpen = modalList.some(modal => modal.isShow && modal.id === modalId)

  const openModal = (e: MouseEvent<HTMLElement>, { reviewGroupId, reactionStat, nClickArea }: ReactionModalProps) => {
    _openModal({ reviewGroupId, reactionStat, nClickArea })
  }

  return { openReactionModal: openModal, isReactionModalOpen }
}

export default useReactionModal
